<template lang="pug">
.bg-grey.w-full.p-40
  .notes.max-w-718
    BriqPanel
      template(name="header")
        .flex.justify-between.align-start
          h2.h2.mb-S External Notes
          BriqButton(
            v-if="businessAllowsEditNotes"
            small
            @click="saveExternalRemark"
            :disabled="remarkIsDisabled"
            variant="secondary"
            data-test-id="save-booking-note-button"
            ) Save
      template
        BriqTextarea.mb-S(
          :maxlength="5000" 
          v-model="externalBookingRemark"
          :rows="6" 
          withCharacterCounter 
          :disabled="remarkIsDisabled" 
          data-test-id="booking-note-textarea")
    BriqPanel
      template(name="header")
        .flex.justify-between.align-start
          h2.h2.mb-S Reference
          BriqButton(
            v-if="businessAllowsEditNotes"
            small
            @click="saveReferenceProxy"
            :disabled="referenceIsDisabled"
            variant="secondary"
            data-test-id="save-booking-reference-button"
            ) Save
      template
        BriqInput.mb-S(
          :maxlength="100"
          v-model="bookingReference"
          :rows="3"
          withCharacterCounter
          :disabled="referenceIsDisabled"
          data-test-id="booking-reference-textarea"
          )
  .notes.max-w-718
    BriqPanel
      template(name="header")
        .flex.justify-between.align-start
          h2.h2.mb-S Internal Notes
          BriqButton(
            v-if="businessAllowsEditNotes"
            small
            @click="saveInternalRemark"
            :disabled="remarkIsDisabled"
            variant="secondary"
            data-test-id="save-booking-note-button"
          ) Save
      template
        BriqTextarea.mb-S(
          :maxlength="5000"
          v-model="internalBookingRemark"
          :rows="6"
          withCharacterCounter
          :disabled="remarkIsDisabled"
          data-test-id="booking-note-textarea")
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import { BookingRemarkApiModel } from '@v/bookings/details/BookingDetailsApiModel.js'
import BusinessFeature from '@v/models/BusinessFeatureEnum.js'
import Permission from '@v/models/UserPermissionEnum.js'

export default {
  name: 'NotesTab',
  data() {
    return {
      externalBookingRemark: null,
      internalBookingRemark: null,
      bookingReference: null,
    }
  },
  computed: {
    ...mapState('bookingDetails', ['isSaving', 'saveError']),
    ...mapGetters('bookingDetails', ['internalRemark', 'externalRemark', 'reference', 'booking']),
    ...mapGetters('briqState', ['businessUnitHasFeature', 'userHasPermission']),
    businessAllowsEditNotes() {
      return this.businessUnitHasFeature(BusinessFeature.BookingEditNotes)
    },
    remarkIsDisabled() {
      return (
        !this.businessAllowsEditNotes ||
        this.isSaving ||
        !this.userHasPermission(Permission.API_Admin_Booking_Remark_Create)
      )
    },
    referenceIsDisabled() {
      return this.remarkIsDisabled
    },
  },
  methods: {
    ...mapActions('bookingDetails', ['saveReference', 'saveRemark', 'fetchBookingDetails']),
    async saveExternalRemark() {
      await this.saveRemarkProxy(false)
    },
    async saveInternalRemark() {
      await this.saveRemarkProxy(true)
    },
    async saveRemarkProxy(isPrivate) {
      const newRemark = new BookingRemarkApiModel({
        Key: isPrivate ? this.internalRemark?.Key || null : this.externalRemark?.Key || null,
        Remark: isPrivate ? this.internalBookingRemark : this.externalBookingRemark,
        Private: isPrivate,
      })
      const {saved, bookingKey} = await this.saveRemark(newRemark)
      
      if (saved) this.$notifySuccess('Note saved')
      if (bookingKey) this.fetchBookingDetails(bookingKey)
      else
        this.$handleError({
          error: this.saveError,
          notification: 'Something went wrong while saving note',
        })
    },
    async saveReferenceProxy() {
      const success = await this.saveReference(this.bookingReference)
      if (success) this.$notifySuccess('Reference saved')
      else
        this.$handleError({
          error: this.saveError,
          notification: 'Something went wrong while saving reference',
        })
    },
  },
  watch: {
    externalRemark: {
      handler(v) {
        this.externalBookingRemark = v?.Remark
      },
      immediate: true,
    },
    internalRemark: {
      handler(v) {
        this.internalBookingRemark = v?.Remark
      },
      immediate: true,
    },
    reference: {
      handler(v) {
        this.bookingReference = v
      },
      immediate: true,
    },
  },
  beforeMount() {
    this.$setDocumentTitle(`Booking ${this.booking.Number} notes`)
  },
}
</script>

<style lang="stylus" scoped>
.notes
  display flex
  // max-width 718px
  // flex-direction column // todo: responsive

  .briq-panel
    width 600px
    margin-right 32px

.header
  display flex
  justify-content space-between

p
  background-color #f1f3f6
  border solid 1px #ececec
  padding 8px 12px 10px 11px

.modal-actions
  display flex
  justify-content center
</style>

<style lang="stylus">
.notes

  .briq-panel
    width 600px
    margin-right 32px
</style>
